/** First-class step statuses besides pass/fail. */
export const SMOKE_SKIP = 'skip'
export const SMOKE_BLOCKED = 'blocked'

export function scenarioStatusFromSteps(steps = []) {
  if (steps.some((s) => s.status === 'fail')) return 'fail'
  if (steps.some((s) => s.status === 'blocked')) return 'blocked'
  return 'pass'
}

export function summarizeSmokeResults(results = []) {
  return {
    pass: results.filter((r) => r.status === 'pass').length,
    fail: results.filter((r) => r.status === 'fail').length,
    skip: results.filter((r) => r.status === SMOKE_SKIP).length,
    blocked: results.filter((r) => r.status === SMOKE_BLOCKED).length
  }
}
